const leftItems = [
  "RO Making Beep Sound",
  "LCD Indicators Not Displayed",
  "TDS Level Increased",
  "RO Dispensing Less or No Water"
];

const rightItems = [
  "Water Leakage Bad Taste or Smell",
  "Vibrations or Noise in RO Purifier",
  "Low Water Flow or Slow Storage Tank Filling",
  "RO Purifier Not Working"
];

function Features() {
  return (
    <section className="features">
      <div className="container">

        <div className="row">

          <div className="col-12">
            <h2 className="title-2">
              Facing the Below Problems?
            </h2>
          </div>

          {/* LEFT */}

          <div className="col-lg-4 featureLeft">
            <div className="feature-lft">
              <ul>

                {leftItems.map((item, index) => (
                  <li key={index}>

                    <img
                      src="/images/drop.png"
                      alt=""
                      width="35"
                      height="35"
                    />

                    <span>{item}</span>

                  </li>
                ))}

              </ul>
            </div>
          </div>

          {/* CENTER */}

          <div className="col-lg-4">
            <div className="feature-mid">

              <img
                src="/images/center-image.png"
                alt="RO Service"
                width="340"
                height="340"
                fetchPriority="high"
              />

            </div>
          </div>

          {/* RIGHT */}

          <div className="col-lg-4 featureRight">
            <div className="feature-rt">

              <ul>

                {rightItems.map((item, index) => (
                  <li key={index}>

                    <img
                      src="/images/drop.png"
                      alt=""
                      width="35"
                      height="35"
                    />

                    <span>{item}</span>

                  </li>
                ))}

              </ul>

            </div>
          </div>

          {/* CTA */}

          <div className="col-12">

            <div className="fetureCta">

              <p>
                Your RO Needs Immediate Service
              </p>

              <span>
                For Booking Call:
              </span>

              <a href="tel:18005711030">
                18005711030
              </a>

            </div>

          </div>

        </div>
      </div>
    </section>
  );
}

export default Features;